import { makeStyles } from 'tss-react/mui';
import { useIsMobile } from '@uplift/hooks';
import { Button } from '@uplift/ui-v2';

import {
  StepContainer, StepContent, StepDescription, StepHeading, StepNavigator
} from '../../components';

export type TooYoungProps = {
  onBack: () => void;
  title?: string;
  description?: string;
};

export const TooYoung: React.VFC<TooYoungProps> = props => {
  const isMobile = useIsMobile('sm');
  const { classes } = useTooYoungStyles();

  return (
    <StepContainer>
      <StepContent className={classes.content}>
        <StepHeading>{props.title ?? 'Sorry, we don’t treat people who are 12 or younger'}</StepHeading>
        <StepDescription>{props.description ?? 'UpLift only accepts clients who are 13 and older.'}</StepDescription>
        <div>
          <Button
            color="secondary"
            variant="contained"
            className={classes.button}
            fullWidth={isMobile}
            component="a"
            href="https://joinuplift.co"
            testId="go-to-homepage-btn"
          >
            Go to homepage
          </Button>
        </div>
      </StepContent>
      <StepNavigator onBack={props.onBack} desktopOnly />
    </StepContainer>
  );
};

const useTooYoungStyles = makeStyles({ name: 'TooYoung' })(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  button: {
    marginTop: theme.spacing(3)
  }
}));
